import { getProposedAppointments } from "api/appointments";
import { GET_PROPOSED_APPOINTMENTS } from "@constants/reactQueryKeys";
import { useQuery } from "react-query";

export const useGetProposedAppointments = (options = {}) => {
  const queryRes = useQuery([GET_PROPOSED_APPOINTMENTS], () => getProposedAppointments(), {
    refetchOnWindowFocus: false,
    ...options,
  });
  const { data, isLoading, ...rest } = queryRes;
  const appointmentsData = data?.data || null;
  return {
    proposedAppointments: appointmentsData,
    proposedAppointmentsLoading: isLoading,
    ...rest,
  };
}